import { Component, OnInit, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { WpapiService } from 'src/app/services/wpapi.service';
import { Observable } from 'rxjs';
import { fadeAnimation, fadeAnimationResponsive } from 'src/app/animations/animation';
import { Related } from 'src/app/interfaces/related.interface';
import { RelatedService } from 'src/app/services/related.service';
import { Router } from '@angular/router';
import { PageService } from 'src/app/services/page.service';


@Component({
    selector: 'app-related-posts',
    templateUrl: './related-posts.component.html',
    styleUrls: ['./related-posts.component.scss'],
    animations: [fadeAnimationResponsive, fadeAnimation]
})
export class RelatedPostsComponent implements OnInit {
    @Input() tags: any;
    @Input() title: string;
    @Input() counter: number;
    works: any = [];
    shuffleworks: any = [];
    relatedOverlay: Related[] = [];
    requestId;
    width: number = 0;
    activeRelated: number;
    lastActive: number;
    interval;
    isNotPaused: boolean = false;
    data$: Observable<any>;
    labelwidth: number = 0;
    screenWidth: number = 0;
    animate: boolean = false;

    @Output() relatedActive: EventEmitter<any> = new EventEmitter<any>();

    constructor(private wpApi: WpapiService,
        private related: RelatedService,
        private router: Router,
        private pageService: PageService) {
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit() {
        this.wpApi.getRelatedWorks().subscribe(resp => {
            this.handleResponse(resp);
        })
        this.interval = setInterval(() => {
            if (this.isNotPaused) {
                if (this.width >= 100) {
                    this.width = 0;
                    this.callBackSlide();
                } else {
                    this.width++;
                }
            }
        }, 200);
    }

    handleResponse(resp) {
        this.works = this.shuffle(resp);
        if (this.screenWidth > 1024) {
            this.labelwidth = 50;
        } else {
            this.labelwidth = 40;
        }
    }
    
    shuffle(sourceArray) {
        for (var i = 0; i < sourceArray.length - 1; i++) {
            var j = i + Math.floor(Math.random() * (sourceArray.length - i));

            var temp = sourceArray[j];
            sourceArray[j] = sourceArray[i];
            sourceArray[i] = temp;
        }
        return sourceArray;
    }

    handleAnimation(work) {
        if (this.screenWidth > 1024) {
            this.relatedOverlay = [];
            this.relatedOverlay.push({
                title: work.title.rendered,
                subtitle: work.acf.subtitle,
                image: work.acf.project_modules[0].banner_gallery[0].banner_item,
                colors: work.acf.project_modules[0].banner_gallery[0].title_and_subtitle_color
            });
            this.related.setRelatedOverlay(this.relatedOverlay);

            setTimeout(() => {
                this.relatedActive.emit(work.slug);
            }, 300);
        } else {
            this.pageService.animateSingle();
            this.pageService.goToTop();
            setTimeout(() => {
                this.router.navigate(['/works/' + work.slug]);
            }, 300);
        }
    }

    loadedImage(i) {
        document.getElementById('related-image-' + i).classList.add('loaded');
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (visible) {
            this.activeRelated = 0;
            setTimeout(() => {
                this.lastActive = 0;
            }, 500);
            this.animate = true;
            this.isNotPaused = true;
        } else {
            this.isNotPaused = false;
        }
    }

    callBackSlide() {
        this.activeRelated++;
        if (this.activeRelated >= 3) {
            this.activeRelated = 0;
        }
        setTimeout(() => {
            this.lastActive++;
            if (this.lastActive >= 3) {
                this.lastActive = 0;
            }
        }, 400);
    }

    activeSlide(i) {
        this.width = 0;
        this.activeRelated = i;
        if (this.activeRelated >= 3) {
            this.activeRelated = 0;
        }
        if (this.activeRelated < 0) {
            this.activeRelated = 2;
        }
        setTimeout(() => {
            this.lastActive = i;
            if (this.lastActive >= 3) {
                this.lastActive = 0;
            }
            if (this.lastActive < 0) {
                this.lastActive = 2;
            }
        }, 400);
    }

    onSwipeLeft() {
        if (this.screenWidth <= 1024) {
            var nextSlide = this.activeRelated + 1;
            this.activeSlide(nextSlide);
        }
    }

    onSwipeRight() {
        if (this.screenWidth <= 1024) {
            var prevSlide = this.activeRelated - 1;
            this.activeSlide(prevSlide);
        }
    }
}
